<template lang="html">
  <section class="panel-evenement section">
    <div class="container-fluid">               
      <div class="row">
          <div class="col-md-6">
              <h2 v-html="titre"></h2>
              <p>{{message}}</p>
          </div>
          <div class="col-md-10"></div>
      </div>

      <div class="row cards" v-if="evenements.length > 0">
        <div class="col-md-4 col-lg-3" v-for="(e, index) in evenements" :key="index">
          <card-evenement :titre="e.titre" :lieu="e.lieu" :date="e.debut" :mois="e.mois" :jour="e.jour" :image="e.image" :evenementId="e.id"/>
        </div>
      </div>
      <panel-aucun-evenement v-else-if="(evenements.length <= 0) && !loading"/>
      <panel-loading v-if="loading"/>
    </div>
  </section>

</template>

<script lang="js">
  import CardEvenement from '@/components/CardEvenement'
  import PanelAucunEvenement from '@/components/PanelAucunEvenement'
  import PanelLoading from '@/components/PanelLoading'

  import axios from 'axios'

  export default  {
    name: 'panel-evenement',
    props: [
      'type',
      'titre',
      'message'
    ],
    data() {
      return {
        evenements : [],
        loading : true
      }
    },
    created() {

    },
    mounted() {
      this.getEvenements();
    },
    methods: {
      getEvenements : function(){
        var url = "https://skanticket.com/tousevenements.php";
        if(this.type=='CINEMA'){
          url = "https://skanticket.com/touscinema.php"
        }
        else if(this.type=='EVENEMENTS'){
          url = "https://skanticket.com/tousconcert.php"
        }
        axios
        .get(url)
        .then(response => {
          this.loading = false;
          this.evenements = response.data.donnee;
        })
      }
    },
    computed: {

    },
    components : {
      CardEvenement,
      PanelAucunEvenement,
      PanelLoading
    }
}
</script>

<style>
  .panel-evenement{
    margin-top: 1.5em;
}
</style>

